import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f10df072 = () => interopDefault(import('../pages/account-management.vue' /* webpackChunkName: "pages/account-management" */))
const _a77c5870 = () => interopDefault(import('../pages/account-management/apis-webhooks.vue' /* webpackChunkName: "pages/account-management/apis-webhooks" */))
const _dc120b34 = () => interopDefault(import('../pages/account-management/basic.vue' /* webpackChunkName: "pages/account-management/basic" */))
const _65da3233 = () => interopDefault(import('../pages/account-management/billing.vue' /* webpackChunkName: "pages/account-management/billing" */))
const _420c7b35 = () => interopDefault(import('../pages/account-management/company.vue' /* webpackChunkName: "pages/account-management/company" */))
const _60d6b1da = () => interopDefault(import('../pages/account-management/plans-and-billing.vue' /* webpackChunkName: "pages/account-management/plans-and-billing" */))
const _02f1a19e = () => interopDefault(import('../pages/account-management/settings/branded-links.vue' /* webpackChunkName: "pages/account-management/settings/branded-links" */))
const _5ed49b3f = () => interopDefault(import('../pages/account-management/settings/compliance.vue' /* webpackChunkName: "pages/account-management/settings/compliance" */))
const _4a2189f4 = () => interopDefault(import('../pages/account-management/settings/notifications.vue' /* webpackChunkName: "pages/account-management/settings/notifications" */))
const _30fee400 = () => interopDefault(import('../pages/additional-details.vue' /* webpackChunkName: "pages/additional-details" */))
const _933d03ea = () => interopDefault(import('../pages/automations/index.vue' /* webpackChunkName: "pages/automations/index" */))
const _4d12e972 = () => interopDefault(import('../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _42412f3e = () => interopDefault(import('../pages/company-details.vue' /* webpackChunkName: "pages/company-details" */))
const _5dd15992 = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _7a50547a = () => interopDefault(import('../pages/contacts/index.vue' /* webpackChunkName: "pages/contacts/index" */))
const _b70b9e70 = () => interopDefault(import('../pages/contacts/columns/index.vue' /* webpackChunkName: "pages/contacts/columns/index" */))
const _40440277 = () => interopDefault(import('../pages/contacts/import-history/index.vue' /* webpackChunkName: "pages/contacts/import-history/index" */))
const _7c21fa80 = () => interopDefault(import('../pages/contacts/lists/index.vue' /* webpackChunkName: "pages/contacts/lists/index" */))
const _2fd1a03e = () => interopDefault(import('../pages/contacts/lists/create.vue' /* webpackChunkName: "pages/contacts/lists/create" */))
const _2fd0b738 = () => interopDefault(import('../pages/contacts/lists/_id/subscribers.vue' /* webpackChunkName: "pages/contacts/lists/_id/subscribers" */))
const _9c1730cc = () => interopDefault(import('../pages/contacts/_communicationPreference.vue' /* webpackChunkName: "pages/contacts/_communicationPreference" */))
const _6585a963 = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _5617bc10 = () => interopDefault(import('../pages/email-verification.vue' /* webpackChunkName: "pages/email-verification" */))
const _559bbc72 = () => interopDefault(import('../pages/getting-started/index.vue' /* webpackChunkName: "pages/getting-started/index" */))
const _b678bc08 = () => interopDefault(import('../pages/growth-tools/index.vue' /* webpackChunkName: "pages/growth-tools/index" */))
const _fdc8985c = () => interopDefault(import('../pages/inbox.vue' /* webpackChunkName: "pages/inbox" */))
const _e0848c92 = () => interopDefault(import('../pages/inbox/_threads.vue' /* webpackChunkName: "pages/inbox/_threads" */))
const _af622e36 = () => interopDefault(import('../pages/inbox/_threads/_id/index.vue' /* webpackChunkName: "pages/inbox/_threads/_id/index" */))
const _11372c03 = () => interopDefault(import('../pages/integrations.vue' /* webpackChunkName: "pages/integrations" */))
const _7d494242 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _e09f9290 = () => interopDefault(import('../pages/pay-as-you-go.vue' /* webpackChunkName: "pages/pay-as-you-go" */))
const _478abfb9 = () => interopDefault(import('../pages/plans/index.vue' /* webpackChunkName: "pages/plans/index" */))
const _7b11fb17 = () => interopDefault(import('../pages/admin/clients/index.vue' /* webpackChunkName: "pages/admin/clients/index" */))
const _0bbece0e = () => interopDefault(import('../pages/admin/reports/index.vue' /* webpackChunkName: "pages/admin/reports/index" */))
const _5d88c345 = () => interopDefault(import('../pages/admin/templates.vue' /* webpackChunkName: "pages/admin/templates" */))
const _1702fb10 = () => interopDefault(import('../pages/admin/templates/_tab.vue' /* webpackChunkName: "pages/admin/templates/_tab" */))
const _66f5b0ca = () => interopDefault(import('../pages/campaigns/name.vue' /* webpackChunkName: "pages/campaigns/name" */))
const _baf31580 = () => interopDefault(import('../pages/campaigns/new.vue' /* webpackChunkName: "pages/campaigns/new" */))
const _d431ab4e = () => interopDefault(import('../pages/campaigns/objective.vue' /* webpackChunkName: "pages/campaigns/objective" */))
const _4e297228 = () => interopDefault(import('../pages/growth-tools/keyword/create.vue' /* webpackChunkName: "pages/growth-tools/keyword/create" */))
const _c0f2145c = () => interopDefault(import('../pages/admin/template-design/_tid.vue' /* webpackChunkName: "pages/admin/template-design/_tid" */))
const _326456d5 = () => interopDefault(import('../pages/admin/template-design/_tid/index.vue' /* webpackChunkName: "pages/admin/template-design/_tid/index" */))
const _10e905bc = () => interopDefault(import('../pages/admin/template-design/_tid/content/_cid.vue' /* webpackChunkName: "pages/admin/template-design/_tid/content/_cid" */))
const _21e5e046 = () => interopDefault(import('../pages/admin/template-design/_tid/section/_sid.vue' /* webpackChunkName: "pages/admin/template-design/_tid/section/_sid" */))
const _5ba2797e = () => interopDefault(import('../pages/growth-tools/keyword/_id/index.vue' /* webpackChunkName: "pages/growth-tools/keyword/_id/index" */))
const _24bc5843 = () => interopDefault(import('../pages/growth-campaigns/join/_clientId/_growthCampaignId/index.vue' /* webpackChunkName: "pages/growth-campaigns/join/_clientId/_growthCampaignId/index" */))
const _2c53ff14 = () => interopDefault(import('../pages/growth-campaigns/join/_clientId/_growthCampaignId/privacy-policy.vue' /* webpackChunkName: "pages/growth-campaigns/join/_clientId/_growthCampaignId/privacy-policy" */))
const _c63e71da = () => interopDefault(import('../pages/growth-campaigns/join/_clientId/_growthCampaignId/terms-and-conditions.vue' /* webpackChunkName: "pages/growth-campaigns/join/_clientId/_growthCampaignId/terms-and-conditions" */))
const _d8356e66 = () => interopDefault(import('../pages/contacts-upload/_action.vue' /* webpackChunkName: "pages/contacts-upload/_action" */))
const _5a262e2a = () => interopDefault(import('../pages/automations/_id/analytics.vue' /* webpackChunkName: "pages/automations/_id/analytics" */))
const _e4bc2ca6 = () => interopDefault(import('../pages/automations/_id/selected-automation.vue' /* webpackChunkName: "pages/automations/_id/selected-automation" */))
const _1c757ade = () => interopDefault(import('../pages/campaigns/_id/analytics.vue' /* webpackChunkName: "pages/campaigns/_id/analytics" */))
const _71c798c9 = () => interopDefault(import('../pages/campaigns/_id/audience.vue' /* webpackChunkName: "pages/campaigns/_id/audience" */))
const _bb00aa7a = () => interopDefault(import('../pages/campaigns/_id/design.vue' /* webpackChunkName: "pages/campaigns/_id/design" */))
const _6c7859f4 = () => interopDefault(import('../pages/campaigns/_id/design/index.vue' /* webpackChunkName: "pages/campaigns/_id/design/index" */))
const _0a056bfc = () => interopDefault(import('../pages/campaigns/_id/design/preview.vue' /* webpackChunkName: "pages/campaigns/_id/design/preview" */))
const _1b2217d1 = () => interopDefault(import('../pages/campaigns/_id/design/content/_cid.vue' /* webpackChunkName: "pages/campaigns/_id/design/content/_cid" */))
const _457c7af5 = () => interopDefault(import('../pages/campaigns/_id/design/section/_sid.vue' /* webpackChunkName: "pages/campaigns/_id/design/section/_sid" */))
const _333c835d = () => interopDefault(import('../pages/campaigns/_id/review.vue' /* webpackChunkName: "pages/campaigns/_id/review" */))
const _36d89524 = () => interopDefault(import('../pages/campaigns/_id/sms.vue' /* webpackChunkName: "pages/campaigns/_id/sms" */))
const _c2cd5f82 = () => interopDefault(import('../pages/campaigns/_id/template.vue' /* webpackChunkName: "pages/campaigns/_id/template" */))
const _15499dc8 = () => interopDefault(import('../pages/contacts-upload/_id/confirm-headers.vue' /* webpackChunkName: "pages/contacts-upload/_id/confirm-headers" */))
const _2fee69d2 = () => interopDefault(import('../pages/contacts-upload/_id/import.vue' /* webpackChunkName: "pages/contacts-upload/_id/import" */))
const _99ad6130 = () => interopDefault(import('../pages/contacts-upload/_id/map-data.vue' /* webpackChunkName: "pages/contacts-upload/_id/map-data" */))
const _7bd174e2 = () => interopDefault(import('../pages/contacts-upload/_id/number-lookups.vue' /* webpackChunkName: "pages/contacts-upload/_id/number-lookups" */))
const _4c5097c4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account-management",
    component: _f10df072,
    name: "account-management",
    children: [{
      path: "apis-webhooks",
      component: _a77c5870,
      name: "account-management-apis-webhooks"
    }, {
      path: "basic",
      component: _dc120b34,
      name: "account-management-basic"
    }, {
      path: "billing",
      component: _65da3233,
      name: "account-management-billing"
    }, {
      path: "company",
      component: _420c7b35,
      name: "account-management-company"
    }, {
      path: "plans-and-billing",
      component: _60d6b1da,
      name: "account-management-plans-and-billing"
    }, {
      path: "settings/branded-links",
      component: _02f1a19e,
      name: "account-management-settings-branded-links"
    }, {
      path: "settings/compliance",
      component: _5ed49b3f,
      name: "account-management-settings-compliance"
    }, {
      path: "settings/notifications",
      component: _4a2189f4,
      name: "account-management-settings-notifications"
    }]
  }, {
    path: "/additional-details",
    component: _30fee400,
    name: "additional-details"
  }, {
    path: "/automations",
    component: _933d03ea,
    name: "automations"
  }, {
    path: "/campaigns",
    component: _4d12e972,
    name: "campaigns"
  }, {
    path: "/company-details",
    component: _42412f3e,
    name: "company-details"
  }, {
    path: "/contacts",
    component: _5dd15992,
    children: [{
      path: "",
      component: _7a50547a,
      name: "contacts"
    }, {
      path: "columns",
      component: _b70b9e70,
      name: "contacts-columns"
    }, {
      path: "import-history",
      component: _40440277,
      name: "contacts-import-history"
    }, {
      path: "lists",
      component: _7c21fa80,
      name: "contacts-lists"
    }, {
      path: "lists/create",
      component: _2fd1a03e,
      name: "contacts-lists-create"
    }, {
      path: "lists/:id/subscribers",
      component: _2fd0b738,
      name: "contacts-lists-id-subscribers"
    }, {
      path: ":communicationPreference",
      component: _9c1730cc,
      name: "contacts-communicationPreference"
    }]
  }, {
    path: "/dashboard",
    component: _6585a963,
    name: "dashboard"
  }, {
    path: "/email-verification",
    component: _5617bc10,
    name: "email-verification"
  }, {
    path: "/getting-started",
    component: _559bbc72,
    name: "getting-started"
  }, {
    path: "/growth-tools",
    component: _b678bc08,
    name: "growth-tools"
  }, {
    path: "/inbox",
    component: _fdc8985c,
    name: "inbox",
    children: [{
      path: ":threads?",
      component: _e0848c92,
      name: "inbox-threads",
      children: [{
        path: ":id",
        component: _af622e36,
        name: "inbox-threads-id"
      }]
    }]
  }, {
    path: "/integrations",
    component: _11372c03,
    name: "integrations"
  }, {
    path: "/maintenance",
    component: _7d494242,
    name: "maintenance"
  }, {
    path: "/pay-as-you-go",
    component: _e09f9290,
    name: "pay-as-you-go"
  }, {
    path: "/plans",
    component: _478abfb9,
    name: "plans"
  }, {
    path: "/admin/clients",
    component: _7b11fb17,
    name: "admin-clients"
  }, {
    path: "/admin/reports",
    component: _0bbece0e,
    name: "admin-reports"
  }, {
    path: "/admin/templates",
    component: _5d88c345,
    name: "admin-templates",
    children: [{
      path: ":tab?",
      component: _1702fb10,
      name: "admin-templates-tab"
    }]
  }, {
    path: "/campaigns/name",
    component: _66f5b0ca,
    name: "campaigns-name"
  }, {
    path: "/campaigns/new",
    component: _baf31580,
    name: "campaigns-new"
  }, {
    path: "/campaigns/objective",
    component: _d431ab4e,
    name: "campaigns-objective"
  }, {
    path: "/growth-tools/keyword/create",
    component: _4e297228,
    name: "growth-tools-keyword-create"
  }, {
    path: "/admin/template-design/:tid?",
    component: _c0f2145c,
    children: [{
      path: "",
      component: _326456d5,
      name: "admin-template-design-tid"
    }, {
      path: "content/:cid?",
      component: _10e905bc,
      name: "admin-template-design-tid-content-cid"
    }, {
      path: "section/:sid?",
      component: _21e5e046,
      name: "admin-template-design-tid-section-sid"
    }]
  }, {
    path: "/growth-tools/keyword/:id",
    component: _5ba2797e,
    name: "growth-tools-keyword-id"
  }, {
    path: "/growth-campaigns/join/:clientId?/:growthCampaignId",
    component: _24bc5843,
    name: "growth-campaigns-join-clientId-growthCampaignId"
  }, {
    path: "/growth-campaigns/join/:clientId?/:growthCampaignId?/privacy-policy",
    component: _2c53ff14,
    name: "growth-campaigns-join-clientId-growthCampaignId-privacy-policy"
  }, {
    path: "/growth-campaigns/join/:clientId?/:growthCampaignId?/terms-and-conditions",
    component: _c63e71da,
    name: "growth-campaigns-join-clientId-growthCampaignId-terms-and-conditions"
  }, {
    path: "/contacts-upload/:action?",
    component: _d8356e66,
    name: "contacts-upload-action"
  }, {
    path: "/automations/:id/analytics",
    component: _5a262e2a,
    name: "automations-id-analytics"
  }, {
    path: "/automations/:id/selected-automation",
    component: _e4bc2ca6,
    name: "automations-id-selected-automation"
  }, {
    path: "/campaigns/:id/analytics",
    component: _1c757ade,
    name: "campaigns-id-analytics"
  }, {
    path: "/campaigns/:id/audience",
    component: _71c798c9,
    name: "campaigns-id-audience"
  }, {
    path: "/campaigns/:id/design",
    component: _bb00aa7a,
    children: [{
      path: "",
      component: _6c7859f4,
      name: "campaigns-id-design"
    }, {
      path: "preview",
      component: _0a056bfc,
      name: "campaigns-id-design-preview"
    }, {
      path: "content/:cid?",
      component: _1b2217d1,
      name: "campaigns-id-design-content-cid"
    }, {
      path: "section/:sid?",
      component: _457c7af5,
      name: "campaigns-id-design-section-sid"
    }]
  }, {
    path: "/campaigns/:id/review",
    component: _333c835d,
    name: "campaigns-id-review"
  }, {
    path: "/campaigns/:id/sms",
    component: _36d89524,
    name: "campaigns-id-sms"
  }, {
    path: "/campaigns/:id/template",
    component: _c2cd5f82,
    name: "campaigns-id-template"
  }, {
    path: "/contacts-upload/:id?/confirm-headers",
    component: _15499dc8,
    name: "contacts-upload-id-confirm-headers"
  }, {
    path: "/contacts-upload/:id?/import",
    component: _2fee69d2,
    name: "contacts-upload-id-import"
  }, {
    path: "/contacts-upload/:id?/map-data",
    component: _99ad6130,
    name: "contacts-upload-id-map-data"
  }, {
    path: "/contacts-upload/:id?/number-lookups",
    component: _7bd174e2,
    name: "contacts-upload-id-number-lookups"
  }, {
    path: "/",
    component: _4c5097c4,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
